import { render, staticRenderFns } from "./SelfAssessmentsDue.vue?vue&type=template&id=0225ce2a&"
import script from "./SelfAssessmentsDue.vue?vue&type=script&lang=js&"
export * from "./SelfAssessmentsDue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports